export default __webpack_public_path__ + "static/media/store_svg10.fd62d6d8.svg";